import { useRequest } from 'ahooks';
import http from '@/utils/http';
import { RequrstBack } from '@/pages/aigc/types/server';
import { queryInitStatClientConfig } from '@/pages/aigc/constants/server';

// 获取图表列表创建人
export const useGetChartCreatorData = <T,>(params: T) => {
  const fetch = () =>
    http({
      url: '/api/v1/datalab/getChartSearch',
      method: 'post',
      data: params,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'getChartCreatorData',
    retryCount: 0,
  });
  return {
    ...data,
  };
};
